module.exports = __webpack_public_path__ + "assets/f3533064c03fcc991c9501f76d66ce7e.mp3";